import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'react-tippy'


export default class LegendEntry extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    image: PropTypes.any,
    is_target: PropTypes.number,
    toolTip: PropTypes.any.isRequired,
  }
  static defaultProps = {
    is_target: 0,
  }

  render() {
    const {title, image, is_target, toolTip} = this.props

    return (
      <div style={{display: 'flex'}}>
          <Tooltip
            html={toolTip}
            sticky
            arrow
            position="top-end"
            trigger="click"
          >
            <div style={{cursor: 'pointer'}}>
              <div style={{width: 80}}>
                <div className="shadow"
                     style={{
                       width: 50,
                       margin: '0 auto',
                       borderRadius: '50%',
                       padding: 7,
                       border: '1px solid #ecf0fc',
                       backgroundColor: 'white',
                       textAlign: 'right',
                     }}>
                  {!!is_target ?
                    <span>
                      <i className="fas fa-circle"
                         style={{color: '#EE6352', display: 'block', marginBottom: -15, marginRight: -15}}/>
                      <div style={{width: 35, height: 35}}></div>
                    </span>
                      :
                    <img src={image} alt=""
                         style={{margin: '0 auto', display: 'block', width: 35, height: 35}}/>
                  }
                </div>
                <div style={{
                  fontSize: 13,
                  textAlign: 'center',
                  padding: 3,
                  whiteSpace: 'initial'
                }}>
                  {title}
                </div>
              </div>
            </div>
          </Tooltip>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/Pathways/LegendEntry.js